const CollectionFilterSalesTypes = (el, onChangeFilterParams) => {


  let filterParams = []


  const initialize = () => {
    el.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', e => {
        if (e.target.checked) {
          onChangeFilterParams([...filterParams, {key: e.target.name, value: e.target.value}])
          return
        }
        const newFilterParams = filterParams.filter(kv => kv.key != e.target.name || kv.value != e.target.value)
        onChangeFilterParams(newFilterParams)
      })
    })
  }


  const setFilterParams = (newFilterParams) => {
    filterParams = newFilterParams

    el.querySelectorAll('input').forEach(input => {
      input.checked = false
      if (0 <= newFilterParams?.findIndex(kv => kv.key == input.name && kv.value == input.value)) {
        input.checked = true
      }
    })
  }


  initialize()

  return {
    setFilterParams: setFilterParams
  }
}


export default CollectionFilterSalesTypes
